import { Typography } from 'antd';

/**
 * ICP 备案号（`hsmsx.cn` 主域备案「沪ICP备16041565号-11」），链接到工信部备案系统。
 * 5 个 PC Web 端（hospital / ops / supplier / gov / system）登录页共用，
 * 备案信息只在这一处维护，避免各端分叉或与 web-www 门户页脚口径漂移。
 */
export const ICP_NUMBER = '沪ICP备16041565号-11';

/** 工业和信息化部政务服务平台备案查询页（与 web-www 页脚同一外链）。 */
const BEIAN_URL = 'https://beian.miit.gov.cn/';

/** 登录页卡片底部的备案号行（继承次要文字色，不抢表单视觉）。 */
export function IcpFooter() {
  return (
    <Typography.Paragraph type="secondary" style={{ textAlign: 'center', fontSize: 12, margin: '8px 0 0' }}>
      <a
        href={BEIAN_URL}
        target="_blank"
        rel="noopener noreferrer nofollow"
        title="工业和信息化部政务服务平台"
        style={{ color: 'inherit' }}
      >
        {ICP_NUMBER}
      </a>
    </Typography.Paragraph>
  );
}
